export const environment = {
  production: false,
  authServiceUrl: 'https://ir2-test.internal.sparbankensyd.se/service',
  irApiUrl: 'https://ir2-test.internal.sparbankensyd.se/api',
  domain: 'ir2-test.internal.sparbankensyd.se',
  bvArn: 'arn:aws:lambda:eu-west-1:225460548507:function:bolagsverket-api-stage',

  testMode: true
}
